export default __webpack_public_path__ + "static/media/br_ad_banner.3184b148.jpg";